import React, { useEffect, useState } from 'react'
import CloseIcon from '../../assets/icon/CloseIcon'
import Modal from '../Modal'
import styles from './ProjectRenameModal.module.scss'

interface ProjectRenameModalProps {
    isOpen: boolean
    defaultName: string
    title?: string
    onClose: () => void
    onConfirm: (name: string) => Promise<void> | void
}

export default function ProjectRenameModal({
    isOpen,
    defaultName,
    title = 'Переименовать проект',
    onClose,
    onConfirm,
}: ProjectRenameModalProps) {
    const [name, setName] = useState(defaultName)
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        if (isOpen) setName(defaultName)
    }, [defaultName, isOpen])

    const handleConfirm = async () => {
        const nextName = name.trim()
        if (!nextName || isSubmitting) return

        setIsSubmitting(true)
        try {
            await onConfirm(nextName)
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} width={446}>
            <div className={styles.rename}>
                <button type="button" className={styles.renameClose} onClick={onClose} aria-label="Закрыть">
                    <CloseIcon />
                </button>
                <h3 className={styles.renameTitle}>{title}</h3>
                <input
                    className={styles.renameInput}
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') void handleConfirm()
                        if (event.key === 'Escape') onClose()
                    }}
                    autoFocus
                />
                <div className={styles.renameActions}>
                    <button type="button" className={styles.renameCancel} onClick={onClose} disabled={isSubmitting}>
                        Отменить
                    </button>
                    <button
                        type="button"
                        className={styles.renameSubmit}
                        onClick={() => void handleConfirm()}
                        disabled={isSubmitting || !name.trim()}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </Modal>
    )
}
